import { Option } from 'types/types';
import styled from 'styled-components';
import { FormatOptionLabelMeta } from 'react-select';
import { ReactComponent as CheckIconComponent } from 'images/v2/icons/svg/fill/svg/check.svg';

export const reactSelectPropsForHtmlLabel = {
  formatOptionLabel: (option: Option, meta: FormatOptionLabelMeta<Option>) => {
    const { context, selectValue } = meta;

    const isSelected = Array.isArray(selectValue) && selectValue.some((selected) => selected.value === option.value);

    if (context === 'menu') {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <SubSupWithoutShift dangerouslySetInnerHTML={{ __html: option.label }} />
          {isSelected && <CheckIconComponent />}
        </div>
      );
    }

    return <SubSupWithoutShift dangerouslySetInnerHTML={{ __html: option.label }} />;
  },
};

// Default browser styles for sub/sup cause shift of line height
const SubSupWithoutShift = styled.span`
  sub {
    vertical-align: baseline;
    position: relative;
    top: 0.33em;
  }
  sup {
    vertical-align: baseline;
    position: relative;
    top: -0.33em;
  }
`;
